import i18n from '@dms/i18n';
import {tiresInventoryRoutes} from '@dms/routes';
import {Section, Tires} from '@dms/shared';

import {composePath} from 'shared/web';

import {TireSets} from './components/TireSets';

interface TiresOverviewProps {
  vehicleId: string;
  customerId: string;
}

export function TiresOverview(props: TiresOverviewProps) {
  return (
    <Section
      isFullHeight
      tabs={[
        {
          content: <TireSets vehicleId={props.vehicleId} customerId={props.customerId} />,
          queryId: 'tireSets',
          title: i18n.t('page.tiresInventory.labels.tireSets'),
        },
        {
          content: (
            <Tires
              vehicleId={props.vehicleId}
              createNewLink={composePath(tiresInventoryRoutes.createTireOrder, {
                queryParams: {
                  customerId: props.customerId,
                  vehicleId: props.vehicleId,
                },
                isSearchParamsPreserved: false,
              })}
              gridCode="tire-order-wheel-service-case"
            />
          ),
          queryId: 'tires',
          title: i18n.t('page.tiresInventory.labels.tires'),
        },
      ]}
    />
  );
}
